import React, { Component, Suspense } from "react";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import "./Register.scss";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Icon from "react-icons-kit";
import { eye } from "react-icons-kit/fa/eye";
import { eyeSlash } from "react-icons-kit/fa/eyeSlash";
// import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import JejakinLogo from "./../../../images/jejakin-marketplace.svg";
// import JejakinLogoIcon from "./../../../images/jejakin-marketplace-icon.svg";
import "./Register.scss";
import i18n from 'i18next';
import { Translation } from "react-i18next";

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaderButton: false,
      email: null,
      password: null,
      phone: null,
      fullName: null,
      companyName: null,
      success: null,
      error: null,
      message: null,
      redirectToLogin: false,
      checkOptRegister: "personal",
      showpassword: false,
    };
  }
  showPassword = () => {
    this.setState({ showpassword: !this.state.showpassword });
  };
  checkPassword = (value) => {
    this.setState({ password: value }, () => {});
  };
  changeAccType = (e) => {
    console.log("a ", e.target.value);
    this.setState({
      checkOptRegister: e.target.value,
      fullName: null,
      companyName: null,
      email: null,
      password: null,
    });
  };
  registerPersonal = (e) => {
    e.preventDefault();
    this.setState({ loaderButton: true });
    let data = {
      email: this.state.email,
      password: this.state.password,
      fullName: this.state.fullName,
    };
    if (this.state.password && this.state.password.length > 5) {
      axios({
        method: "POST",
        url: process.env.REACT_APP_API_HOST + "/register/user/personal",
        data: data,
      }).then(
        (response) => {
          if (response.data.status === true) {
            this.setState({
              success: response.data.status,
              message: i18n.t('PleaseCheckEmailToConfirm'),
            });
            setTimeout(() => {
              toast.success(i18n.t('Success') + "! " + i18n.t('PleaseCheckEmailToConfirm') );
              this.setState({ loaderButton: false });
            }, 1000);
            setTimeout(() => {
              this.setState({ redirectToLogin: true });
            }, 10000);
          } else {
            if (response.data.error.length) {
              for (var er = 0; er < response.data.error.length; er++) {
                var obj = response.data.error[er];
                for (var key in obj) {
                  console.log(key, obj[key]);
                  toast.error(i18n.t(obj[key]));
                }
                this.setState({ loaderButton: false });
              }
            } else {
              this.setState({ loaderButton: false });
              toast.error(response.data.error);
            }
          }
        },
        (error) => {
          setTimeout(() => {
            toast.error("Error! " + error);
            this.setState({ loaderButton: false });
          }, 1000);
        }
      );
    } else {
      this.setState({ loaderButton: false });
      toast.error(i18n.t('PasswordMustSixChar'));
    }
  };

  registerBusiness = (e) => {
    e.preventDefault();
    this.setState({ loaderButton: true });
    let data = {
      email: this.state.email,
      password: this.state.password,
      companyName: this.state.companyName,
    };
    if (this.state.password && this.state.password.length > 5) {
      axios({
        method: "POST",
        url: process.env.REACT_APP_API_HOST + "/register/user/business",
        data: data,
      }).then(
        (response) => {
          if (response.data.status === true) {
            this.setState({
              success: response.data.status,
              message: i18n.t('PleaseCheckEmailToConfirm'),
            });
            setTimeout(() => {
              toast.success(i18n.t('Success') + "! " + i18n.t('PleaseCheckEmailToConfirm') );
              this.setState({ loaderButton: false });
            }, 1000);
            setTimeout(() => {
              this.setState({ redirectToLogin: true });
            }, 10000);
          } else {
            if (response.data.error.length) {
              for (var er = 0; er < response.data.error.length; er++) {
                var obj = response.data.error[er];
                for (var key in obj) {
                  console.log(key, obj[key]);
                  toast.error(i18n.t(obj[key]));
                }
                this.setState({ loaderButton: false });
              }
            } else {
              this.setState({ loaderButton: false });
              toast.error(response.data.error);
            }
          }
        },
        (error) => {
          setTimeout(() => {
            toast.error("Error! " + error);
            this.setState({ loaderButton: false });
          }, 1000);
        }
      );
    } else {
      this.setState({ loaderButton: false });
      toast.error("Password harus 6 character atau lebih");
    }
  };

  render() {
    if (localStorage.getItem("userData")) {
      return <Redirect to={"/profile"} />;
    }
    if (this.state.redirectToLogin) {
      return <Redirect to={"/login"} />;
    }
    return (
      <React.Fragment>
        <div className="mpl-page">
          <ToastContainer />
          <Suspense fallback={"...Loading"}>
            <Translation>
              {(t) => (
                <div className="wrap-account">
                  <div className="wp-ac wrap-left">
                    <div className="logo-fixed">
                      <Link to="/">
                        <img src={JejakinLogo} alt="Jejakin" />
                      </Link>
                    </div>
                    <div className="wp-login">
                      {/* <h2>Buat Akun</h2> */}
                      <div className="row">
                        <div className="col-auto">
                          <h3 className="ts-underline mb-5">
                            {t("login_register.daftar")}
                          </h3>
                        </div>
                        <div className="col-auto">
                          <h3 className="ts-underline no-bg mb-5">
                            <Link to="/login">{t("login_register.masuk")}</Link>
                          </h3>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="label-group" htmlFor="fullname">
                          {t("login_register.jenis_akun")}
                        </label>
                        <select
                          name="changeAccType"
                          id="changeAccType"
                          className="field-group"
                          onChange={this.changeAccType}
                          value={this.state.checkOptRegister}
                        >
                          <option value="personal">Personal</option>
                          <option value="business">
                            {t("login_register.business")}
                          </option>
                        </select>
                      </div>
                      <form
                        id="formRegisterPersonal"
                        className={`${
                          this.state.checkOptRegister === "personal"
                            ? "form-show"
                            : "form-hide"
                        }`}
                      >
                        <div className="form-group">
                          <label className="label-group" htmlFor="fullname">
                            {t("login_register.nama_lengkap")}
                          </label>
                          <input
                            id="fullname"
                            type="text"
                            className="field-group"
                            name="name"
                            onChange={(e) =>
                              this.setState({ fullName: e.target.value })
                            }
                            value={this.state.fullName || ""}
                          />
                        </div>
                        <div className="form-group">
                          <label className="label-group" htmlFor="email">
                            Email
                          </label>
                          <input
                            id="email"
                            type="text"
                            className="field-group"
                            name="email"
                            onChange={(e) =>
                              this.setState({ email: e.target.value })
                            }
                            value={this.state.email || ""}
                          />
                        </div>
                        <div className="form-group">
                          <label className="label-group" htmlFor="password">
                            {t("login_register.password")}
                          </label>
                          {this.state.showpassword ? (
                            <div className="field-group-input">
                              <input
                                id="password"
                                type="text"
                                className="field-group"
                                name="password"
                                onChange={(e) =>
                                  this.setState({ password: e.target.value })
                                }
                                value={this.state.password || ""}
                              />
                              <div className="icon-group">
                                <Icon
                                  size={24}
                                  icon={eye}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    this.showPassword();
                                  }}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="field-group-input">
                              <input
                                id="password"
                                type="password"
                                className="field-group"
                                name="password"
                                onChange={(e) =>
                                  this.setState({ password: e.target.value })
                                }
                                value={this.state.password || ""}
                              />
                              <div className="icon-group">
                                <Icon
                                  size={24}
                                  icon={eyeSlash}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    this.showPassword();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="form-group mb-0">
                          <button
                            id="btnRegisterPersonal"
                            className="btn btn-green btn-block text-center"
                            onClick={this.registerPersonal}
                          >
                            {this.state.loaderButton === true ? (
                              <div className="loader"></div>
                            ) : (
                              t("login_register.daftar_personal")
                            )}
                          </button>
                        </div>
                      </form>
                      <form
                        id="formRegisterBusiness"
                        className={`${
                          this.state.checkOptRegister === "business"
                            ? "form-show"
                            : "form-hide"
                        }`}
                      >
                        <div className="form-group">
                          <label htmlFor="companyName" className="label-group">
                            {t("login_register.nama_perusahaan")}
                          </label>
                          <input
                            id="companyName"
                            type="text"
                            className="field-group"
                            name="text"
                            onChange={(e) =>
                              this.setState({ companyName: e.target.value })
                            }
                            value={this.state.companyName || ""}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="email-b" className="label-group">
                            Email
                          </label>
                          <input
                            id="email-b"
                            type="text"
                            className="field-group"
                            name="email-b"
                            onChange={(e) =>
                              this.setState({ email: e.target.value })
                            }
                            value={this.state.email || ""}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="password-b" className="label-group">
                            {t("login_register.password")}
                          </label>
                          {this.state.showpassword ? (
                            <div className="field-group-input">
                              <input
                                id="password-b"
                                type="text"
                                className="field-group"
                                name="password-b"
                                onChange={(e) =>
                                  this.setState({ password: e.target.value })
                                }
                                value={this.state.password || ""}
                              />
                              <div className="icon-group">
                                <Icon
                                  size={24}
                                  icon={eye}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    this.showPassword();
                                  }}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="field-group-input">
                              <input
                                id="password-b"
                                type="password"
                                className="field-group"
                                name="password-b"
                                onChange={(e) =>
                                  this.setState({ password: e.target.value })
                                }
                                value={this.state.password || ""}
                              />
                              <div className="icon-group">
                                <Icon
                                  size={24}
                                  icon={eyeSlash}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    this.showPassword();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="form-group mb-0">
                          <button
                            id="btnRegisterBusiness"
                            className="btn btn-green btn-block text-center"
                            onClick={this.registerBusiness}
                          >
                            {this.state.loaderButton === true ? (
                              <div className="loader"></div>
                            ) : (
                              t("login_register.daftar_bisnis")
                            )}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="wp-ac wrap-right">
                    <div className="green-ov">&nbsp;</div>
                    <div className="content-highlight">
                      <h2>{t("login_register.quote")}</h2>
                    </div>
                    <div className="foot">
                      <span className="copyright">
                        © 2020 Jejak.in, All rights reserved
                      </span>
                      <span className="float-right social-link">
                        <a href="https://bit.ly/2BiY5n0" target="_blank">
                          <i className="fab fa-linkedin-in"></i>
                        </a>{" "}
                        <a href="https://bit.ly/2Bk6d6M" target="_blank">
                          <i className="fab fa-youtube"></i>
                        </a>{" "}
                        <a href="https://bit.ly/32yy8eb" target="_blank">
                          <i className="fab fa-instagram"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </Translation>
          </Suspense>
        </div>
      </React.Fragment>
    );
  }
}

export default Register;
